export const SESSIONS_GUEST = 'GUEST'
export const SESSIONS_BOOKING = 'BOOKING'
export const SESSIONS_EMPLOYEE = 'EMPLOYEE'
export const SESSIONS_BALANCE = 'BALANCE'
